import { ParticipantAuthorityPayload } from "@/store/modules/account/account.types";
import axios from "axios";

export const accountApi = {
  async getAccount() {
    const response = await axios.get(`${process.env.VUE_APP_SUMARI_SERVER_URL}/account`);
    return response;
  },
  async pushAccountToBcm(accountData: any) {
    return axios.put('account', accountData);
  },
  getParticipantAuthority(participantAuthorityPayload: ParticipantAuthorityPayload) {
    const { projectId, userId } = participantAuthorityPayload;
    return axios.get(`account/${projectId}/participant-authority/${userId}`);
  }
}